var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"botton-box"},[_c('div',{staticClass:"bar"},[_c('div',{staticClass:"title-echarts"},[_vm._v("病虫害种类及数量")]),_c('Echart',{attrs:{"option":_vm.option}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }